export default __webpack_public_path__ + "static/media/danielle-testemonials.0bb666b7.png";